import config from '@config';
export default function canvasTmplConfig(opts = {}) {
  const vm =this;
  function font(size) {
    return `${size}px bold arial, 微软雅黑, sans-serif`;
  }
  const {
    binding,
    back_img,
  } = opts

  console.log(opts)

  return {
    renderList: [{
      type: 'image',
      src: back_img,
      width: 1280,
      height: 2276,
      x: 0,
      y: 0
    }, {
      type: 'image',
      src: binding,
      width: 222,
      height: 222,
      x: 994,
      y: 1800
    }],
    rendered(){
      const src = this.canvas.toDataURL("image/png");
      if (config.device.isApp) {
        dtb.shareImage(src);
      } else {
        vm.imgSrc = src;
      }


    }
  };
}
